export class ConstanteAngular {

    public static APLICATION_DEFAULT = 'APP-0002'
    public static TYPE_USER_DEFAULT = 'PAR-0011'
    public static JWT_RESPONSE_HEADER = 'token';
    public static JWT_RESPONSE_FORM = 'form';
    public static JWT_RESPONSE_USER = 'user';
    public static JWT_RESPONSE_PROFILE = 'pv';
    public static CC_RESPONSE_HEADER = 'cc';
    public static TYPE_USER = 'TYPE_USER';
    public static ID_FOLDER_ABASTECIMIENTO_OS = "1IRbKwxnuihGSmMlODc-cksS4DltBcSST";
    public static ID_ANIO = "2025";
    public static ID_OS = "OS";

    public static USER_DOCUMENT = '00000000';
    /** para cuando se quiere ver los listados desde los menus**/
    public static ACCION_SOLICITADA_LISTAR = "LISTAR";

    /** desde la venta de listado se da click en boton nuevo **/
    public static ACCION_SOLICITADA_NUEVO = "NUEVO";

    /** desde la ventana de listado se desea modificar la informacion de un registro **/
    public static ACCION_SOLICITADA_EDITAR = "EDITAR";

    /** desde la ventana de listado se desea anular un registro en forma logica**/
    public static ACCION_SOLICITADA_ANULAR = "ANULAR";

    /** desde la ventana de listado se desea eliminar fisicamente un registro **/
    public static ACCION_SOLICITADA_ELIMINAR = "ELIMINAR";

    public static ACCION_SOLICITADA_VER = "VER";

    public static ACCION_SOLICITADA_COPIAR = 'COPIAR';
    public static ACCION_SOLICITADA_GUARDAR = 'GUARDAR';
    public static ACCION_SOLICITADA_SALIR = 'SALIR';
    public static ACCION_SOLICITADA_BUSCAR = "BUSCAR";

    //MENU SEGURIDAD
    public static MENUSEGURIDAD = 'menu-seguridad';

    //FILTROS
    public static FILTROSESION = 'filtrosession';
    public static RUTA = 'ruta';

    //Combos
    public static COMBOTODOS = 'Todos';
    public static COMBOTODOS_NULL = ' ';
    public static COMBOSELECCIONE = 'Seleccione';

    static readonly ESTADO_ACTIVO: "A";

    public static PROVEEDORMAST = "PROVEEDORMAST";


}

